import "./TutorialTool.scss";
// REACT; REDUX; ROUTER
import React, { useEffect, useState } from "react";

// COMPONENTD & FUNCTIONS
import { addAnimation } from "../../functions/animationHandler";

// INTERFACES
import { TutorialToolProps } from "../../interface/propTypesInterface";
import { TutorialStep } from "../../interface/functionalityInterface";

// IMG's, SVGs & Audios
import successAudio from "../../sound/success.mp3";

/*
 TUTORIALTOOL COMPONENT INFORMATION

*/

export default function TutorialTool(props: TutorialToolProps) {
  //::::: CONSTANTS :::::
  const { reactComponent, tutorialSteps, closeTutorial } = props;

  // ::::: USE HOOKS :::::
  const [show, setShow] = useState(false);
  const [componentElem, setComponentElem] = useState<HTMLElement | null>();
  const [steps, setSteps] = useState<TutorialStep[]>(tutorialSteps);
  const [stepNr, setStepNr] = useState(0);

  // Insert the logic for how to handle the imported ReactElement here
  useEffect(() => {
    setShow(true);
    setComponentElem(document.getElementById(reactComponent?.props.id!));
  }, []);

  useEffect(() => {
    if (show) {
      document.documentElement.style.overflow = "hidden";
      window.addEventListener("keydown", handleKeyPress);
    } else {
      document.documentElement.style.overflow = "scroll";
      window.removeEventListener("keydown", handleKeyPress);
    }
    return () => {
      document.documentElement.style.overflow = "scroll";
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [show]);

  // ::::: HANDLER FUNCTIONS :::::
  const handleStep = (direction: "nextStep" | "prevStep") => {
    // hide the hintbar if shown
    const hintBar = document.getElementById("tutorial-hint");
    hintBar?.classList.remove("show");
    const newNr = direction === "nextStep" ? stepNr + 1 : stepNr - 1;
    const selectedStep = steps[newNr];

    // Render new step number
    setStepNr(newNr);
    // Mark previous step as complete
    const stepsPrevComplete = [
      ...steps.map((step, i) =>
        stepNr === i && direction !== "prevStep"
          ? { ...step, isCompleted: true }
          : step
      ),
    ];
    setSteps(stepsPrevComplete);

    // If step is completed, don't start any listeners
    if (selectedStep.isCompleted) return;
    // Change focusElem
    // const focusElem = componentElem?.querySelector(newStep.focusQuery!);
    // If there is a eventlistener, then we must complete the tasks first
    if (selectedStep.task && selectedStep.eventListenerType) {
      // If listener exists
      // Add event listener
      document.addEventListener(
        selectedStep.eventListenerType,
        function listener(e) {
          // If first listener returns true
          if (selectedStep.task!(e)) {
            // Remove the first eventlistener
            document.removeEventListener(
              selectedStep.eventListenerType!,
              listener
            );
            // If there is a second listener
            handleSuccess();
            setSteps([
              ...stepsPrevComplete.map((step, i) =>
                newNr === i ? { ...step, isCompleted: true } : step
              ),
            ]);
          }
        }
      );
      // if this step just includes text, don't handleSuccess, just mark as completed
    }
    // else {
    //   setSteps([
    //     ...steps.map((step, i) =>
    //       newNr === i ? { ...step, isCompleted: true } : step
    //     ),
    //   ]);
    // }
  };

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      handleClose();
    }
  };

  const handleClose = () => {
    setShow(false);
    closeTutorial(true);
  };

  const handleSuccess = () => {
    addAnimation(componentElem!, "shakeRotSuccess");
    setTimeout(() => {
      const popup = document.getElementById("tutorial-popup");
      popup?.scrollTo({ top: 0, behavior: "smooth" });
    }, 300);
    // const audio = new Audio(successAudio);
    // audio.volume = 0.3;
    // audio.play();
  };

  // ::::: JSX ::::::
  return (
    <div className="tutorial">
      <aside
        id="tutorial-popup"
        className={show ? "popup visible center" : "popup center"}
      >
        <div className="tutorial__toolbar">
          <button
            className="close-button"
            // style={{ position: "absolute", left: "1.5rem", top: "2rem" }}
            type="button"
            onClick={() => handleClose()}
          ></button>
        </div>
        <div id="tutorial-card" className="tutorial__card">
          <h3 className="tutorial__card-heading">{steps[stepNr].title}</h3>
          <p>
            {steps[stepNr].task && steps[stepNr].isCompleted
              ? steps[stepNr].successText
              : steps[stepNr].text}
          </p>
          {steps[stepNr].helpText && (
            <dd
              id="tutorial-hint"
              onClick={(e) => {
                const target = e.target as Element;
                target.classList.toggle("show");
              }}
            >
              {steps[stepNr].helpText}
            </dd>
          )}
          <div style={{ display: "flex" }}>
            {stepNr > 0 && (
              <button
                className="tutorial__back-button"
                onClick={() => handleStep("prevStep")}
              >
                {steps[stepNr].prevButtonText
                  ? steps[stepNr].prevButtonText
                  : "Back"}
              </button>
            )}
            {stepNr === steps.length - 1 && (
              <button
                type="button"
                className="rectangular-button inverse-color"
                onClick={() => handleClose()}
              >
                Finish
              </button>
            )}
            {stepNr < steps.length - 1 && (
              <button
                className="rectangular-button inverse-color"
                onClick={() => handleStep("nextStep")}
                disabled={
                  steps[stepNr].task && !steps[stepNr].isCompleted
                    ? true
                    : false
                }
              >
                {steps[stepNr].task && !steps[stepNr].isCompleted
                  ? "..."
                  : steps[stepNr].nextButtonText
                  ? steps[stepNr].nextButtonText
                  : "Next"}
              </button>
            )}
          </div>
          <ul className="tutorial__steps-overview">
            {steps.map((step, i) => {
              return (
                <li
                  key={`${step.title}-${i}`}
                  className={`${step.isCompleted ? "is-completed" : ""} ${
                    stepNr === i ? "is-focused" : ""
                  }`}
                ></li>
              );
            })}
          </ul>
        </div>
        <div
          style={
            !steps[stepNr].hideComponent
              ? {}
              : {
                  opacity: 0,
                  height: 0,
                  width: 0,
                  pointerEvents: "none",
                  overflow: "hidden",
                }
          }
          className="tutorial__component"
        >
          {reactComponent}
        </div>
      </aside>
    </div>
  );
}
